import { makeStyles } from '@material-ui/core';
import { colors } from '../../constants.js/colors';

const useStyles = makeStyles({
    root: { width: '100%' },
    container: {
        maxHeight: '570px',
    },
    newContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
    },
    containerDesktop: {
        maxHeight: '560px',
    },
    gridContainer: {
        '& div': {
            maxWidth: 'inherit',
            padding: '8px',
        },
    },
    btn: {
        '& .MuiButton-label': {
            fontSize: 14,
        },
        '& .MuiButton-contained': {
            background: '#fff',
        },
    },
    btnFilter: {
        alignItems: 'flex-end',
        display: 'flex',
        justifyContent: 'center',
        margin: '8px 8px 0px 8px',

        '&:disabled': {
            backgroundColor: '#F6F6F6',
            color: '#8181A5',
        },
    },
    filterInput: {
        backgroundColor: '#fff',
        borderRadius: 8,
        boxShadow:
            '0px 0px 2px rgba(52, 58, 67, 0.1), 0px 1px 2px rgba(52, 58, 67, 0.08), 0px 1px 4px rgba(52, 58, 67, 0.08)',
        color: '#53627C',
        height: 42,
        padding: '14px 16px',
        width: '100%',
    },
    deleteButton: {
        backgroundColor: colors.error.main,
        color: colors.white,
        '&:hover': {
            backgroundColor: colors.error.dark,
        },
    },
});

export default useStyles;
